/* Skreddersøm: sømmen syes nedover mens man scroller, og hvert steg kommer inn
 * fra siden med en knute i sømmen.
 *
 * Uten animasjon står sømmen ferdig tegnet og alle stegene på plass. */

import gsap from 'gsap';
import { $, $$, mindreBevegelse } from '../kjerne/verktoy.js';

export function startSkreddersom() {
  const rad = $('#steg-rad');
  if (!rad || mindreBevegelse.matches) return;

  /* Sømmen tegnes ved å trekke en maske nedover banen. */
  const bane = $('#som-bane');
  const lengde = bane.getTotalLength();
  gsap.set(bane, { strokeDasharray: lengde, strokeDashoffset: lengde });
  gsap.to(bane, {
    strokeDashoffset: 0,
    ease: 'none',
    scrollTrigger: { trigger: rad, start: 'top 65%', end: 'bottom 60%', scrub: true },
  });

  for (const steg of $$('.steg', rad)) {
    const knute = $('.knute', steg);
    gsap.set(knute, { scale: 0 });
    gsap.timeline({
      scrollTrigger: { trigger: steg, start: 'top 62%', toggleActions: 'play none none reverse' },
    })
      .to(knute, { scale: 1, duration: .6, ease: 'back.out(3)' })
      .from(steg.querySelectorAll('.nummer, h3, p'),
        { x: 30, opacity: 0, stagger: .07, duration: .8, ease: 'expo.out' }, 0);
  }
}
